import { authAxios } from './axiosInstance';

export const mobileUserService = {
    async validateUser(token: any) {
        try {
            const response = await authAxios.get(`/users/verify-email/${token}`);
            console.log("details" ,response.data);
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
};